import React, { useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';

import { useApplicationState, useSettings, ZiqniApi, StorageManager } from '@atlas/core';
import { Icon, Label, Loader } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';
import { jwtDecode } from 'jwt-decode';

const { account } = defaultRoutes;
const { getZiqniToken } = ZiqniApi;

const Achievements = () => {
  const { authenticated } = useApplicationState();
  const { lang } = useSettings();
  const languageKey = lang.toLowerCase();
  const [token, setToken] = useState(StorageManager.getItem('tokenZiqni'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authenticated) {
      const storedToken = StorageManager.getItem('tokenZiqni');
      if (storedToken) {
        const decodedToken = jwtDecode(storedToken);
        const currentTimestamp = Math.floor(Date.now() / 1000);
        if (decodedToken.exp > currentTimestamp) {
          setToken(storedToken);
          setLoading(false);
          return;
        }
      }
      getZiqniToken()
        .then(response => {
          setToken(response.token);
          StorageManager.setItem('tokenZiqni', response.token);
        })
        .catch(e => {
          throw new Error(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [authenticated, getZiqniToken]);

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <div className="achievements-page">
        <Link className="back-to-container" to={account}>
          <Icon className="icon-back" name="back" />
          <Label className="title-text" message="achievements" />
        </Link>
        <div className="achievements-content-wrapper">
          {loading ? (
            <div className="achievements-loader">
              <Loader className="absolute" />
            </div>
          ) : !token ? (
            <div className="achievements-error">
              <Icon className="achievements-error-icon" height={48} name="error" width={48} />
              <Label className="achievements-error-title" message="internal_error" />
            </div>
          ) : (
            <iframe
              className="achievements-frame"
              src={`https://first-space.cdn.ziqni.com/AppIframe/build/index.html?auth=${token}&languageKey=${languageKey}`}
            />
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Achievements;
